import _ from "lodash";
import moment from "moment";
import { compareEditDateTimeDesc, finOrderIndex, findIndexByOriginalRowId } from "./GlobalServices";

const getAttributeDashboard = () => {
  return [
    "workRecords",
    "inspections",
    "carryingIO",
    "carryingIORecords",
    "safetyPlans",
    "safetyPlanImprovementPlans",
    "commons",
    "workRecordsQualifiedResponsible",
    "workRecordsEquipments",
    "workRecordsSafetyInstructions",
  ];
};
const getSubAttributeDashboard = (attr) => {
  let attributeRecord = [];
  switch (attr) {
    case "workRecords":
      attributeRecord = [
        "orderPosition",
        "primaryConstractor",
        "subContractor",
        "workType",
        "workDescription",
        "sign",
        "presignedUrl",
        "contractCompanyId",
        "numberOfPeople.budget",
        "numberOfPeople.actual",
        "useOfFire",
      ];
      break;
    case "inspections":
      attributeRecord = [
        "point",
        "time",
        "inspector",
        "result",
        "informed",
        "counterplan",
      ];
      break;
    case "carryingIO":
      attributeRecord = [
        "inOut",
        "estimatedTime.type",
        "estimatedTime.specifiedTime",
        "itemType",
        "loadCapacity",
        "number",
        "memo",
      ];
      break;
    case "carryingIORecords":
      attributeRecord = [
        "inOut",
        "estimatedTime.type",
        "estimatedTime.specifiedTime",
        "itemType",
        "loadCapacity",
        "number",
        "memo",
      ];
      break;
    case "safetyPlans":
      attributeRecord = ["plan", "confirmer", "confirmation"];
      break;
    case "safetyPlanImprovementPlans":
      attributeRecord = ["plan", "confirmer"];
      break;
    case "commons":
      attributeRecord = [
        "commonInstructions",
        "environmentalManagementInstructions",
        "instructionDuringWork.instruction",
        "instructionDuringWork.instructor",
        "instructionDuringWork.instructorPresignedUrl",
        "supervisorPatrolRecord.record",
        "supervisorPatrolRecord.supervisor",
        "supervisorPatrolRecord.supervisorPresignedUrl",
      ];
      break;
    case "workRecordsQualifiedResponsible":
      attributeRecord = ["qualification", "name", "qualificationId"];
      break;
    case "workRecordsEquipments":
      attributeRecord = ["type", "subType", "number", "unit"];
      break;
    case "workRecordsSafetyInstructions":
      attributeRecord = ["type", "instruction", "confirmed"];
      break;
    case "co2InSiteWork":
      attributeRecord = [
        "budget.operatingTime.from",
        "budget.operatingTime.to",
        "budget.number",
        "actual.operatingTime.from",
        "actual.operatingTime.to",
        "actual.number",
        "machineOwner",
        "oldMachineFirstLayer",
        "oldMachineSecondLayer",
        "oldMachineThirdLayer",
      ];
      break;
    case "co2OutSiteWork":
      attributeRecord = [
        "machineType",
        "number",
        "loadCapacity",
        "loadCapacityTrash",
        "transportDistance",
      ];
      break;
    case "co2OutSiteWorkWaste":
      attributeRecord = [
        "machineType",
        "number",
        "loadCapacity",
        "loadCapacityTrash",
        "transportDistance",
      ];
      break;
    case "co2OutSiteWorkContructionSoil":
      attributeRecord = [
        "machineType",
        "number",
        "loadCapacity",
        "loadCapacityTrash",
        "transportDistance",
      ];
      break;
    default:
      break;
  }
  return attributeRecord;
};
const compareRevision = (attr, objType, objRecord) => {
  const typeEditPrevious = objType.typeEditPrevious;
  const typeEditLastest = objType.typeEditLastest;
  let colorControl = {};
  let attributeRecord = getSubAttributeDashboard(attr);

  attributeRecord.forEach((element) => {
    let val = {
      previous: "",
      lastest: "",
      condition: false,
    };
    const pr = _.get(objRecord.previousRecord.record, element, undefined);
    const pl = _.get(objRecord.lastestRecord.record, element, undefined); //Existing while differs
    
    
    // より堅牢な比較ロジック：null/undefined/空文字列を適切に処理
    let compareValue;
    if (pr === pl) {
      // 厳密等価の場合は確実に同じ
      compareValue = true;
    } else if ((pr === null || pr === undefined || pr === "") && 
               (pl === null || pl === undefined || pl === "")) {
      // 両方とも空値系の場合は同じとみなす
      compareValue = true;
    } else if (typeof pr === 'string' && typeof pl === 'string') {
      const prTrimmed = pr.trim();
      const plTrimmed = pl.trim();
      if ((prTrimmed === "" && plTrimmed === "") || prTrimmed === plTrimmed) {
        compareValue = true;
      } else {
        compareValue = false;
      }
    } else if (typeof pr === 'object' && typeof pl === 'object' && pr !== null && pl !== null) {
      // オブジェクトの場合はlodashのisEqualで深い比較
      compareValue = _.isEqual(pr, pl);
    } else if ((pr === null || pr === undefined) && (pl === null || pl === undefined)) {
      // 両方ともnull/undefinedの場合は同じとみなす
      compareValue = true;
    } else {
      // その他の場合は厳密に異なる
      compareValue = false;
    }
    
    val = calcStyle(typeEditPrevious, typeEditLastest, compareValue, false, false, pr, pl);
    
    _.set(colorControl, element, val);
  });
  return colorControl;
};
const createTemplatePreviousValue = (nameRecord) => {
  let temp = {};
  const listAttribute = getSubAttributeDashboard(nameRecord);
  listAttribute.forEach((element) => {
    _.set(temp, element, "");
  });
  return temp;
};
const createTemplate = (nameRecord, type = null) => {
  let result = {};
  let temp = { condition: true, previous: "", lastest: "" };
  if (type == "StatusFocus") {
    temp = false;
  } else if (type == "StyleEditActual") {
    // 実施入力時に新規追加されたレコードは赤字で表示する
    temp = { condition: true, previous: "", lastest: "history-color-orange" };
  }
  const listAttribute = getSubAttributeDashboard(nameRecord);
  listAttribute.forEach((element) => {
    _.set(result, element, temp);
  });
  return result;
};
const calcStyle = (
  typeEdit,
  typeEditLastest,
  condition,
  isPreviousNil = false,
  isLatestValueNil = false,
  previousValue = null,
  latestValue = null
) => {
  //condition is "same" or "diff"
  let result = { condition: condition };
  if (isPreviousNil && isLatestValueNil) {
    Object.assign(result, { previous: "", lastest: "history-color-black" });
    return result;
  }

  // 予定入力時は赤文字（orange）を一切表示しない（厳格仕様）
  // see: docs/budget-input-no-red-text-specification.md
  if (typeEditLastest == "budget") {
    if (condition) {
      Object.assign(result, { previous: "", lastest: "history-color-black" });
    } else if (typeEdit == "budget") {
      // 予定→予定の差分: 非表示
      Object.assign(result, {
        previous: "history-color-black",
        lastest: "history-color-black",
        hidden: true,
      });
    } else {
      // actual→予定の差分: 黒文字（赤文字禁止）
      Object.assign(result, {
        previous: "history-color-black",
        lastest: "history-color-black",
        hidden: true,
      });
    }
    return result;
  }

  // 以下、実施入力時（typeEditLastest == "actual"）のロジック
  if (condition) {
    //if true condition's "same"
    // 実施入力時の条件を修正：実際に前の値が空で現在の値が空でない場合のみ赤字
    const actualPreviousNil = previousValue === null || previousValue === undefined || previousValue === "";
    const actualLatestNotNil = latestValue !== null && latestValue !== undefined && latestValue !== "";


    if (actualPreviousNil && actualLatestNotNil) {
      Object.assign(result, { previous: "", lastest: "history-color-orange" });
    } else {
      Object.assign(result, { previous: "", lastest: "history-color-black" });
    }
  } else {
    //diff
    if (typeEdit == "actual") {
      Object.assign(result, {
        previous: "history-line-through history-color-orange",
        lastest: "history-color-orange",
      });
    } else {
      Object.assign(result, {
        previous: "history-line-through history-color-black",
        lastest: "history-color-orange",
      });
    }
  }
  return result;
};
//get lastest and previous diary by diaryId and diaryIdPrevious
const getLastestPreviousDiary = (diaries, diaryId, diaryIdPrevious) => {

  const result = [];

  // tempDiaryIDの場合は特別処理
  if (diaryId === "tempDiaryID") {
    // flagDiaryIdがtempDiaryIDのものを最新として取得
    const tempDiary = _.find(
      diaries,
      (diary) => diary.flagDiaryId === "tempDiaryID"
    );
    if (tempDiary) {
      result.push(tempDiary);

      // diaryIdPreviousが指定されている場合はそれも取得
      if (diaryIdPrevious) {
        const previousDiary = _.find(
          diaries,
          (diary) => diary.diaryId === diaryIdPrevious
        );
        if (previousDiary) {
          result.push(previousDiary);
        }
      } else {
        // diaryIdPreviousが指定されていない場合は2番目に新しいリビジョンを取得
        // 同じ revision の diary がある場合は editDateTime で降順ソートして最新を取得
        const sortedDiaries = _.cloneDeep(diaries)
          .filter((diary) => !diary.flagDiaryId) // flagDiaryIdがないものだけ
          .sort((a, b) => {
            // まず revision で降順ソート
            if (b.revision !== a.revision) {
              return b.revision - a.revision;
            }
            // revision が同じ場合は editDateTime で降順ソート
            return compareEditDateTimeDesc(a, b);
          });

        if (sortedDiaries.length > 0) {
          result.push(sortedDiaries[0]);
        }
      }

      return result;
    }
  }

  // 通常処理
  const diaryCurrentlyView = _.find(diaries, (diary) => {
    return diary.diaryId == diaryId;
  });
  const firstRevision = _.minBy(diaries, (diary) => {
    return diary.revision;
  });
  if (diaryCurrentlyView == firstRevision) {
    return [diaryCurrentlyView];
  }

  for (let i in diaries) {
    if (
      diaries[i].diaryId == diaryId ||
      diaries[i].diaryId == diaryIdPrevious
    ) {
      result.push(diaries[i]);
    }
  }

  const sortedResult = result.sort(compareEditDateTimeDesc);
  return sortedResult;
};
//get diaries were not lastest and preivous
const getDiariesOlder = (diaries, diaryId, diaryIdPrevious) => {
  const result = [];
  //sort diary reviison by editDateTime
  for (let i in diaries) {
    if (
      diaries[i].diaryId != diaryId &&
      diaries[i].diaryId != diaryIdPrevious
    ) {
      result.push(diaries[i]);
    }
  }
  return result.sort(compareEditDateTimeDesc);
};
const separateLastestPreviousDiary = (diaryRevisions, attr) => {
  let diaryPrevious = [];
  let diaryLastest = [];
  switch (attr) {
    case "carryingIO":
      diaryPrevious = diaryRevisions[1]["carryingIORecords"];
      diaryLastest = diaryRevisions[0]["carryingIORecords"];
      break;
    case "carryingIORecords":
      diaryPrevious = diaryRevisions[1]["carryingIORecords"];
      diaryLastest = diaryRevisions[0]["carryingIORecords"];
      break;
    case "commons":
      diaryPrevious = {
        commonInstructions: diaryRevisions[1].commonInstructions,
        environmentalManagementInstructions:
          diaryRevisions[1].environmentalManagementInstructions,
        instructionDuringWork: {
          instruction: diaryRevisions[1].instructionDuringWork.instruction,
          instructor: diaryRevisions[1].instructionDuringWork.instructor,
          instructorPresignedUrl:
            diaryRevisions[1].instructionDuringWork.instructorPresignedUrl,
        },
        supervisorPatrolRecord: {
          record: diaryRevisions[1].supervisorPatrolRecord.record,
          supervisor: diaryRevisions[1].supervisorPatrolRecord.supervisor,
          supervisorPresignedUrl:
            diaryRevisions[1].supervisorPatrolRecord.supervisorPresignedUrl,
        },
      };
      diaryLastest = {
        commonInstructions: diaryRevisions[0].commonInstructions,
        environmentalManagementInstructions:
          diaryRevisions[0].environmentalManagementInstructions,
        instructionDuringWork: {
          instruction: diaryRevisions[0].instructionDuringWork.instruction,
          instructor: diaryRevisions[0].instructionDuringWork.instructor,
          instructorPresignedUrl:
            diaryRevisions[0].instructionDuringWork.instructorPresignedUrl,
        },
        supervisorPatrolRecord: {
          record: diaryRevisions[0].supervisorPatrolRecord.record,
          supervisor: diaryRevisions[0].supervisorPatrolRecord.supervisor,
          supervisorPresignedUrl:
            diaryRevisions[0].supervisorPatrolRecord.supervisorPresignedUrl,
        },
      };
      break;
    default:
      diaryPrevious = diaryRevisions[1][attr];
      diaryLastest = diaryRevisions[0][attr];
      break;
  }
  return { diaryPrevious: diaryPrevious, diaryLastest: diaryLastest };
};

const compareLastestPreviousDiary = (
  attr,
  diaryLastest,
  diaryPrevious,
  objType,
  templates
) => {
  //loop last workRecord Lastest revision
  let { isFocusTemplate, recordTemplate, styleTemplate } = templates;
  const result = [];
  diaryLastest.forEach((dlastest) => {
    let recordTemp = Object.assign({}, dlastest);
    let flagCheck = false;
    let diaryTemp = {};
    const diaryPreviousLength = diaryPrevious.length;

    for (let i = 0; i <= diaryPreviousLength - 1; i++) {
      let dprevious = diaryPrevious[i];
      // originalRowIdベースで前回リビジョンとの対応付けを行う（順序変更時の差分改善）
      // originalRowIdがない既存データの場合はorderベースのフォールバック
      const hasOriginalRowId = recordTemp.record?.originalRowId != undefined && dprevious.record?.originalRowId != undefined;
      const originalRowIdMatch = hasOriginalRowId && recordTemp.record.originalRowId == dprevious.record.originalRowId;
      const orderMatch = recordTemp.order != undefined && recordTemp.order == dprevious.order;

      if (originalRowIdMatch || (!hasOriginalRowId && orderMatch)) {
        flagCheck = true;
        let objRecord = {
          previousRecord: dprevious,
          lastestRecord: recordTemp,
        };
        let tempResult = compareRevision(attr, objType, objRecord);
        // ネストされたフィールドの場合、同じ値でも適切なスタイルを適用
        const nestedAttrs = ["workRecordsQualifiedResponsible", "workRecordsEquipments", "workRecordsSafetyInstructions"];
        if (nestedAttrs.includes(attr) && objType.typeEditLastest == "actual") {
          // tempResultの各プロパティについて、conditionがtrueの場合は黒字に設定
          const attributeRecord = getSubAttributeDashboard(attr);
          attributeRecord.forEach((element) => {
            const styleValue = _.get(tempResult, element);
            if (styleValue && styleValue.condition === true) {
              _.set(tempResult, `${element}.lastest`, "history-color-black");
            }
          });
        }
        diaryTemp = Object.assign(
          {},
          recordTemp.record,
          { order: recordTemp.order },
          { orderPosition: recordTemp.orderPosition }, 
          { originalRowId: recordTemp.record?.originalRowId || recordTemp.originalRowId },
          { style: tempResult },
          { previousItem: _.cloneDeep(dprevious.record) },
          { isFocus: { ...isFocusTemplate } }
        );
        break;
      }
    }
    //add diary if old version not found
    if (!flagCheck) {
      diaryTemp = Object.assign(
        {},
        recordTemp.record,
        { order: recordTemp.order },
        { orderPosition: recordTemp.orderPosition },
        { originalRowId: recordTemp.record?.originalRowId || recordTemp.originalRowId },
        { style: styleTemplate },
        { previousItem: recordTemplate },
        { isFocus: { ...isFocusTemplate } }
      );
    }
    result.push(diaryTemp);
  });
  return result;
};
/**
 * 実施入力時の比較対象を決定する
 * 実施入力では常に最後の予定入力（budget）との比較を行う
 * @returns {{ diaryOlder: Array, diaryIdPrevious: string }}
 */
const resolveActualComparisonTarget = (diaries, diaryId, diaryIdPrevious) => {
  const currentDiary = _.find(diaries, { diaryId: diaryId });
  if (currentDiary && currentDiary.editAs === "actual") {
    const lastBudgetDiary = _.maxBy(
      diaries.filter(d => d.editAs === "budget"),
      d => d.revision
    );
    return {
      diaryOlder: [],
      diaryIdPrevious: (lastBudgetDiary && lastBudgetDiary.diaryId !== diaryIdPrevious)
        ? lastBudgetDiary.diaryId
        : diaryIdPrevious,
    };
  }
  return null;
};

const syncCarryingIoLength = (result) => {
  const ios = Array.isArray(result.carryingIO) ? result.carryingIO : [];
  const records = Array.isArray(result.carryingIORecords)
    ? result.carryingIORecords
    : [];
  const target = Math.max(ios.length, records.length);
  while (ios.length < target) {
    ios.push({ style: {}, previousItem: {}, isFocus: {} });
  }
  while (records.length < target) {
    records.push({ style: {}, previousItem: {}, isFocus: {} });
  }
  result.carryingIO = ios;
  result.carryingIORecords = records;
};

const swapDiarySerializer = (
  diaries,
  diaryId,
  diaryIdPrevious,
  initRevisionsState = undefined
) => {
  let diaryOlder = getDiariesOlder(diaries, diaryId, diaryIdPrevious);
  const listCompareRevision = [];
  const result = [];
  // 実施入力時は最後の予定入力との比較のみを行う
  // 中間の予定リビジョンとの比較を除外し、値の変遷による誤った赤字表示を防止
  // 実施→実施の場合も、比較対象を最後の予定入力に差し替える
  const actualTarget = resolveActualComparisonTarget(diaries, diaryId, diaryIdPrevious);
  if (actualTarget) {
    diaryOlder = actualTarget.diaryOlder;
    diaryIdPrevious = actualTarget.diaryIdPrevious;
  }
  //remove diary not need to compare revision
  if (diaries.length > 2) {
    const currentlyLastRevisionId = _.find(diaries, {
      diaryId: diaryId,
    }).revision;
    diaryOlder = _.filter(
      diaryOlder,
      (diary) => diary.revision <= currentlyLastRevisionId
    );
  }
  //generate list revision already compare
  listCompareRevision.push(
    serializerDiaryRevision(diaries, diaryId, diaryIdPrevious)
  );

  diaryOlder.forEach((d) => {
    listCompareRevision.push(
      serializerDiaryRevision(diaries, diaryId, d.diaryId)
    );
  });
  for (const attr of [
    "workRecords",
    "inspections",
    "carryingIO",
    "carryingIORecords",
    "safetyPlans",
    "safetyPlanImprovementPlans",
  ]) {
    let listSubAttr = getSubAttributeDashboard(attr);
    result[attr] = [];

    listCompareRevision?.[0]?.[attr]?.forEach(() => {
      result[attr].push({ style: {}, previousItem: {}, isFocus: {} });
    });
    // PDF テンプレートは carryingIORecords をループしつつ carryingIO[index] を参照するため、
    // 両者の要素数が食い違うと "list object has no element N" で 500 になる。
    // ここで短い側を空スタイルでパディングして長さを揃える。
    if (attr === "carryingIORecords") {
      syncCarryingIoLength(result);
    }
    for (const subAttr of listSubAttr) {
      
      if (!listCompareRevision[0][attr] || !Array.isArray(listCompareRevision[0][attr])) {
        continue;
      }
      
      listCompareRevision[0][attr].forEach((record) => {
        let orderId = record.order;
        let item = findElementRevision(
          listCompareRevision,
          attr,
          orderId,
          subAttr,
          null,
          initRevisionsState
        );
        if (item != null && item.length != 0) {
          _.set(result, [attr, item.index, "order"].join("."), orderId);
          _.set(result, [attr, item.index, subAttr].join("."), item.value);
          _.set(
            result,
            [attr, item.index, "style", subAttr].join("."),
            item.style
          );
          _.set(
            result,
            [attr, item.index, "previousItem", subAttr].join("."),
            item.previousItem
          );
          _.set(
            result,
            [attr, item.index, "isFocus", subAttr].join("."),
            item.isFocus
          );
        }
      });
    }
  }
  // handle revision workRecord
  
  if (listCompareRevision[0]["workRecords"] && Array.isArray(listCompareRevision[0]["workRecords"])) {
    for (let indWorkRecord in listCompareRevision[0]["workRecords"]) {
      
      result["workRecords"][indWorkRecord].qualificatedResponsible = [];
      result["workRecords"][indWorkRecord].equipments = [];
      result["workRecords"][indWorkRecord].safetyInstructions = [];
      
      const workRecord = listCompareRevision[0]["workRecords"][indWorkRecord];
      
      if (workRecord?.qualificatedResponsible && Array.isArray(workRecord.qualificatedResponsible)) {
        workRecord.qualificatedResponsible.forEach(() => {
          result["workRecords"][indWorkRecord].qualificatedResponsible.push({
            style: {},
            previousItem: {},
            isFocus: {},
          });
        });
      }
      
      if (workRecord?.equipments && Array.isArray(workRecord.equipments)) {
        workRecord.equipments.forEach(() => {
          result["workRecords"][indWorkRecord].equipments.push({
            style: {},
            previousItem: {},
            isFocus: {},
          });
        });
      }
      
      if (workRecord?.safetyInstructions && Array.isArray(workRecord.safetyInstructions)) {
        workRecord.safetyInstructions.forEach(() => {
          result["workRecords"][indWorkRecord].safetyInstructions.push({
            style: {},
            previousItem: {},
            isFocus: {},
          });
        });
      }
    }
  }
  let listSubAttr = [];
  
  if (listCompareRevision[0]["workRecords"] && Array.isArray(listCompareRevision[0]["workRecords"])) {
    for (let indWorkRecord in listCompareRevision[0]["workRecords"]) {
      //qualificatedResponsible
      const workRecord = listCompareRevision[0]["workRecords"][indWorkRecord];
      const orderWorkRecord = workRecord.order;
      
      if (workRecord?.qualificatedResponsible && Array.isArray(workRecord.qualificatedResponsible)) {
        workRecord.qualificatedResponsible.forEach((qualificatedResponsible) => {
      let orderId = qualificatedResponsible.order;
      let indexOrderQualificatedResponsible = finOrderIndex(
        workRecord.qualificatedResponsible,
        orderId
      );
      result["workRecords"][indWorkRecord]["qualificatedResponsible"][
        indexOrderQualificatedResponsible
      ].order = orderId;
      let item = null;
      listSubAttr = ["qualification", "name", "qualificationId"];
      for (const subAttr of listSubAttr) {
        item = findElementRevision(
          listCompareRevision,
          "qualificatedResponsible",
          orderId,
          subAttr,
          orderWorkRecord,
          initRevisionsState["workRecords"][indWorkRecord]
        );
        if (item != null && item.length != 0) {
          result["workRecords"][indWorkRecord]["qualificatedResponsible"][
            indexOrderQualificatedResponsible
          ][subAttr] = item.value;
          result["workRecords"][indWorkRecord]["qualificatedResponsible"][
            indexOrderQualificatedResponsible
          ].style[subAttr] = item.style;
          result["workRecords"][indWorkRecord]["qualificatedResponsible"][
            indexOrderQualificatedResponsible
          ].previousItem[subAttr] = item.previousItem;
          result["workRecords"][indWorkRecord]["qualificatedResponsible"][
            indexOrderQualificatedResponsible
          ].isFocus[subAttr] = item.isFocus;
        }
      }
        });
      }
      
      //equipment
      if (workRecord?.equipments && Array.isArray(workRecord.equipments)) {
        workRecord.equipments.forEach((equipment) => {
      let orderId = equipment.order;
      let indexOrderEquipment = finOrderIndex(workRecord.equipments, orderId);
      result["workRecords"][indWorkRecord]["equipments"][
        indexOrderEquipment
      ].order = orderId;

      let item = null;
      listSubAttr = ["type", "subType", "number", "unit"];
      for (const subAttr of listSubAttr) {
        item = findElementRevision(
          listCompareRevision,
          "equipments",
          orderId,
          subAttr,
          orderWorkRecord,
          initRevisionsState["workRecords"][indWorkRecord]
        );
        if (item != null && item.length != 0) {
          result["workRecords"][indWorkRecord]["equipments"][
            indexOrderEquipment
          ][subAttr] = item.value;
          result["workRecords"][indWorkRecord]["equipments"][
            indexOrderEquipment
          ].style[subAttr] = item.style;
          result["workRecords"][indWorkRecord]["equipments"][
            indexOrderEquipment
          ].previousItem[subAttr] = item.previousItem;
          result["workRecords"][indWorkRecord]["equipments"][
            indexOrderEquipment
          ].isFocus[subAttr] = item.isFocus;
        }
      }
        });
      }
      
      //safetyInstructions
      if (workRecord?.safetyInstructions && Array.isArray(workRecord.safetyInstructions)) {
        workRecord.safetyInstructions.forEach((safetyInstruction) => {
      let orderId = safetyInstruction.order;
      let indexOrderSafetyInstruction = finOrderIndex(
        workRecord.safetyInstructions,
        orderId
      );
      result["workRecords"][indWorkRecord]["safetyInstructions"][
        indexOrderSafetyInstruction
      ].order = orderId;
      let item = null;
      listSubAttr = ["type", "instruction", "confirmed"];
      for (const subAttr of listSubAttr) {
        item = findElementRevision(
          listCompareRevision,
          "safetyInstructions",
          orderId,
          subAttr,
          orderWorkRecord,
          initRevisionsState["workRecords"][indWorkRecord]
        );
        if (item != null && item.length != 0) {
          result["workRecords"][indWorkRecord]["safetyInstructions"][
            indexOrderSafetyInstruction
          ][subAttr] = item.value;
          result["workRecords"][indWorkRecord]["safetyInstructions"][
            indexOrderSafetyInstruction
          ].style[subAttr] = item.style;
          result["workRecords"][indWorkRecord]["safetyInstructions"][
            indexOrderSafetyInstruction
          ].previousItem[subAttr] = item.previousItem;
          result["workRecords"][indWorkRecord]["safetyInstructions"][
            indexOrderSafetyInstruction
          ].isFocus[subAttr] = item.isFocus;
        }
      }
        });
      }
    }
  }
  //common
  let itemCommon = null;
  for (let attrCommon of [
    "commonInstructions",
    "environmentalManagementInstructions",
    "instructionDuringWork.instruction",
    "instructionDuringWork.instructor",
    "instructionDuringWork.instructorPresignedUrl",
    "supervisorPatrolRecord.record",
    "supervisorPatrolRecord.supervisor",
    "supervisorPatrolRecord.supervisorPresignedUrl",
  ]) {
    itemCommon = findCommonInstructionRevision(
      listCompareRevision,
      attrCommon,
      initRevisionsState
    );
    if (itemCommon != null && itemCommon.length != 0) {
      _.set(result, "commons." + attrCommon, itemCommon.value);
      _.set(result, "commons." + "style." + attrCommon, itemCommon.style);
      _.set(
        result,
        "commons." + "previousItem." + attrCommon,
        itemCommon.previousItem
      );
      _.set(result, "commons." + "isFocus." + attrCommon, itemCommon.isFocus);
    }
  }
  return result;
};
const findCommonInstructionRevision = (
  listCompareRevision,
  attr,
  initRevisionsState
) => {
  let pathAttr = "commons." + attr;

  const revision = listCompareRevision[listCompareRevision.length - 1];
  const condition = _.get(
    revision,
    ["commons.style", attr, "condition"].join(".")
  );
  const previousValue = _.get(
    initRevisionsState,
    ["commons.previousItem", attr].join("."),
    ""
  );
  if (
    condition &&
    initRevisionsState &&
    listCompareRevision.length >= 2 &&
    previousValue
  ) {
    return {
      value: _.get(initRevisionsState, pathAttr),
      style: _.get(initRevisionsState, ["commons.style", attr].join("."), {}),
      previousItem: previousValue,
      isFocus: _.get(
        initRevisionsState,
        ["commons.isFocus", attr].join("."),
        ""
      ),
    };
  }

  for (let indRevision in listCompareRevision) {
    const revision = listCompareRevision[indRevision];
    let previousIsSame = isSecondNewValueSamePreviousVersionCommon(
      listCompareRevision,
      indRevision,
      attr
    );
    if (
      !_.get(revision, "commons.style." + attr + ".condition", true) &&
      !previousIsSame
    ) {
      return {
        value: _.get(revision, pathAttr),
        style: _.get(revision, "commons.style." + attr),
        previousItem: _.get(revision, "commons.previousItem." + attr),
        isFocus: _.get(revision, "commons.isFocus." + attr),
      };
    }
  }
  return {
    value: _.get(_.first(listCompareRevision), pathAttr),
    style: _.get(_.first(listCompareRevision), "commons.style." + attr),
    previousItem: _.get(
      _.first(listCompareRevision),
      "commons.previousItem." + attr
    ),
    isFocus: _.get(_.first(listCompareRevision), "commons.isFocus." + attr),
  };
};

const getDataCompareRevision = (listCompareRevision, orderParent) => {
  const listDataCompareRevisionTemp = [];
  listCompareRevision.forEach((revision) => {
    let wordRecordQualificatedResponsible = [];
    let wordRecordEquipments = [];
    let wordRecordSafetyIntruction = [];
    revision.workRecords.forEach((workdRecord) => {
      const orderWordRecord = workdRecord.order;

      if (orderWordRecord == orderParent) {
        workdRecord.qualificatedResponsible.forEach(
          (qualificatedResponsible) => {
            wordRecordQualificatedResponsible.push(qualificatedResponsible);
          }
        );
        workdRecord.equipments.forEach((equipment) => {
          wordRecordEquipments.push(equipment);
        });
        workdRecord.safetyInstructions.forEach((safetyIntruction) => {
          wordRecordSafetyIntruction.push(safetyIntruction);
        });
      }
    });
    listDataCompareRevisionTemp.push({
      qualificatedResponsible: wordRecordQualificatedResponsible,
      equipments: wordRecordEquipments,
      safetyInstructions: wordRecordSafetyIntruction,
    });
  });
  return listDataCompareRevisionTemp;
};

const findElementRevision = (
  listCompareRevision,
  attr,
  orderId,
  subAttr,
  orderParent = null,
  initRevisionsState = undefined
) => {
  // console.log("🚀 ~ file: ShowRevisionServices.js ~ line 463 ~ findElementRevision ~ initRevisionsState", initRevisionsState)
  let listDataCompareRevisionTemp = listCompareRevision;
  if (orderParent) {
    //using when attr is equipment and safetyInstructions
    listDataCompareRevisionTemp = getDataCompareRevision(
      listCompareRevision,
      orderParent
    );
  }

  if (
    listDataCompareRevisionTemp != undefined &&
    listDataCompareRevisionTemp.length >= 1
  ) {
    let itemExpect = {
      index: -1,
      style: {},
      value: "",
      previousItem: "",
    };
    try {
      // 直近のリビジョン比較結果をデフォルト値として使用する
      // _.last()（最古のリビジョン）を使うと、古いリビジョンにレコードが存在しない場合に
      // StyleEditActual（全フィールド橙）がデフォルトになり、未変更フィールドまで赤字になる
      let revision =
        listDataCompareRevisionTemp[0][attr] ||
        _.last(listDataCompareRevisionTemp[0]["workRecords"])[attr];
      let indexOrder = finOrderIndex(revision, orderId);
      let result = revision[indexOrder];
      itemExpect.index = indexOrder;
      itemExpect.value = _.get(result, subAttr, "");
      itemExpect.style = _.get(result, ["style", subAttr].join("."), {});
      itemExpect.previousItem = _.get(
        result,
        ["previousItem", subAttr].join("."),
        ""
      );
      itemExpect.isFocus = _.get(result, ["isFocus", subAttr].join("."), "");

      const condition = _.get(
        result,
        ["style", subAttr, "condition"].join(".")
      );
      if (
        condition &&
        initRevisionsState &&
        listDataCompareRevisionTemp.length >= 2 &&
        itemExpect.previousItem
      ) {
        const previewRevision = initRevisionsState[attr];
        const previewRevisionIndexOrder = finOrderIndex(
          previewRevision,
          orderId
        );
        const previewRevisionResult =
          previewRevision[previewRevisionIndexOrder];
        if (previewRevisionIndexOrder >= 0) {
          // index は現在のリストでの位置（indexOrder）のまま変えない。
          // ロード時点の位置を使うと、上の行を削除して位置がずれたときに別の行へ書き込み、
          // order を持たない空行（保存時 400）や order 重複の行ができてしまう。
          itemExpect.value = _.get(previewRevisionResult, subAttr, "");
          itemExpect.style = _.get(
            previewRevisionResult,
            ["style", subAttr].join("."),
            {}
          );
          itemExpect.previousItem = _.get(
            previewRevisionResult,
            ["previousItem", subAttr].join("."),
            ""
          );
          itemExpect.isFocus = _.get(
            previewRevisionResult,
            ["isFocus", subAttr].join("."),
            ""
          );
          return itemExpect;
        }
      }

      for (let i in listDataCompareRevisionTemp) {
        let revision = null;
        revision =
          listDataCompareRevisionTemp[i][attr] ||
          _.last(listDataCompareRevisionTemp[i]["workRecords"])[attr];
        let indexOrder = finOrderIndex(revision, orderId);
        let result = revision[indexOrder];
        const condition = _.get(result, ["style", subAttr, "condition"].join("."));
        if (condition == false) {
          let previousIsSame = isSecondNewValueSamePreviousVersion(
            listDataCompareRevisionTemp,
            i,
            attr,
            indexOrder,
            subAttr
          );
          if (!previousIsSame) {
            // index は過去リビジョンでの位置ではなく、現在のリストでの位置のままにする
            itemExpect.value = _.get(result, subAttr, "");
            itemExpect.style = _.get(result, ["style", subAttr].join("."), {});
            itemExpect.previousItem = _.get(
              result,
              ["previousItem", subAttr].join("."),
              ""
            );
            itemExpect.isFocus = _.get(
              result,
              ["isFocus", subAttr].join("."),
              ""
            );
            break;
          }
        }
      }
      
      // condition == trueの場合（同じ値）で、まだスタイルが設定されていない場合は黒字を設定
      if (Object.keys(itemExpect.style).length === 0) {
        itemExpect.style = { 
          condition: true, 
          previous: "", 
          lastest: "history-color-black" 
        };
      }
      
      return itemExpect;
    } catch (errors) {
      console.log("errors", errors);
      return itemExpect;
    }
  }
  return {};
};
const isSecondNewValueSamePreviousVersion = (
  listDiaryRevisionCompared,
  indexRevision,
  attr,
  indexAttr,
  subAttr,
  sub2Attr = null
) => {
  let subfix = "";
  if (sub2Attr == null) {
    subfix = `${attr}.${indexAttr}.previousItem.${subAttr}`;
  } else {
    subfix = `${attr}.${indexAttr}.previousItem.${subAttr}.${sub2Attr}`;
  }
  let valueSecondNew = _.get(
    listDiaryRevisionCompared,
    [indexRevision, subfix].join(".")
  );
  let indexRevisionTemp = parseInt(indexRevision);
  let valuePreviousSecondNew = null;
  if (indexRevisionTemp < listDiaryRevisionCompared.length) {
    indexRevisionTemp++;
    valuePreviousSecondNew = _.get(
      listDiaryRevisionCompared,
      [indexRevisionTemp, subfix].join(".")
    );
  }
  return valueSecondNew == valuePreviousSecondNew;
};
const isSecondNewValueSamePreviousVersionCommon = (
  listDiaryRevisionCompared,
  indexRevision,
  attr,
  subAttr = null
) => {
  let subfix = "";
  if (subAttr == null) {
    subfix = "commons.previousItem." + attr;
  } else {
    subfix = "commons.previousItem." + attr + "." + subAttr;
  }

  let indexRevisionTemp = parseInt(indexRevision);
  let valueSecondNew = _.get(
    listDiaryRevisionCompared[indexRevisionTemp],
    subfix
  );
  let valuePreviousSecondNew = undefined;
  if (indexRevisionTemp < listDiaryRevisionCompared.length) {
    indexRevisionTemp++;
    valuePreviousSecondNew = _.get(
      listDiaryRevisionCompared[indexRevisionTemp],
      subfix
    );
  }
  return valueSecondNew == valuePreviousSecondNew;
};
const findRevisionColor = (diaryRevisions, diaries) => {
  // records
  let results = {};
  const attributeDashboardContainArray = [
    "workRecords",
    "inspections",
    "carryingIO",
    "carryingIORecords",
    "safetyPlans",
    "safetyPlanImprovementPlans",
    "commons",
    "workRecordsQualifiedResponsible",
    "workRecordsEquipments",
    "workRecordsSafetyInstructions",
  ];
  const attributeWorkRecordCotainArray = [
    "workRecordsQualifiedResponsible",
    "workRecordsEquipments",
    "workRecordsSafetyInstructions",
  ];
  for (const attr of attributeDashboardContainArray) {
    results[attr] = [];
    let objType = {
      typeEditLastest: diaryRevisions[0].editAs,
      typeEditPrevious: diaryRevisions[1].editAs,
    };
    let { diaryPrevious, diaryLastest } = separateLastestPreviousDiary(
      diaryRevisions,
      attr
    );
    let isFocusTemplate = createTemplate(attr, "StatusFocus");
    let styleTemplate = createTemplate(attr);
    if (objType.typeEditLastest == "actual" && diaries.length > 1) {
      styleTemplate = createTemplate(attr, "StyleEditActual");
    }
    let recordTemplate = createTemplatePreviousValue(attr);
    let templates = {
      isFocusTemplate: isFocusTemplate,
      recordTemplate: recordTemplate,
      styleTemplate: styleTemplate,
    };

    if (attr == "commons") {
      let recordTemp = Object.assign({}, diaryLastest);
      let objRecord = {
        previousRecord: { record: diaryPrevious },
        lastestRecord: { record: diaryLastest },
      };
      let tempResult = compareRevision(attr, objType, objRecord);
      let diaryTemp = Object.assign(
        recordTemp,
        { style: tempResult },
        { previousItem: diaryPrevious },
        { isFocus: isFocusTemplate }
      );
      results[attr] = { ...diaryTemp };
    } else if (attributeWorkRecordCotainArray.includes(attr)) {
      let attrTemp = "equipments";
      if (attr == "workRecordsQualifiedResponsible") {
        attrTemp = "qualificatedResponsible";
      } else if (attr == "workRecordsSafetyInstructions") {
        attrTemp = "safetyInstructions";
      }

      // find index of workrecord previous
      if (
        diaryRevisions[0].workRecords != undefined &&
        diaryRevisions[0].workRecords.length > 0
      ) {
        diaryRevisions[0].workRecords.forEach((workRecord) => {
          let indexLastestWork = findIndexByOriginalRowId(
            diaryRevisions[0].workRecords,
            workRecord.record?.originalRowId,
            workRecord.order  // フォールバック用のorder
          );
          let indexPreviousWork = findIndexByOriginalRowId(
            diaryRevisions[1].workRecords,
            workRecord.record?.originalRowId,
            workRecord.order  // フォールバック用のorder
          );
          let lwork =
            diaryRevisions[0].workRecords[indexLastestWork].record[attrTemp];
          let pwork = null;
          if (diaryRevisions[1].workRecords[indexPreviousWork] == undefined) {
            pwork = [];
          } else {
            pwork =
              diaryRevisions[1].workRecords[indexPreviousWork].record[attrTemp];
          }
          let anItem = compareLastestPreviousDiary(
            attr,
            lwork,
            pwork,
            objType,
            templates
          );
          let indexWorkRecord = finOrderIndex(
            results["workRecords"],
            workRecord.order
          );
          results["workRecords"][indexWorkRecord][attrTemp] = anItem;
        });
      }
    } else {
      let items = [];
      items = compareLastestPreviousDiary(
        attr,
        diaryLastest,
        diaryPrevious,
        objType,
        templates
      );
      results[attr] = items;
    }
  }
  return results;
};
const serializerDiaryRevision = (diaries, diaryId, diaryIdPrevious) => {
  let results = [];
  try {
    //pre progress data, handle create first diary
    let diaryRevisions = getLastestPreviousDiary(
      diaries,
      diaryId,
      diaryIdPrevious
    );
    if (diaryRevisions.length == 1) {
      //handle when click oldest diaryRevision
      diaryRevisions.push(_.cloneDeep(diaryRevisions[0]));
    }
    results = _.cloneDeep(diaryRevisions[0]);

    const revisionColors = findRevisionColor(diaryRevisions, diaries);

    // originalRowIdを保持するために、workRecordsを個別にマージ
    if (revisionColors.workRecords && results.workRecords) {
      for (let i = 0; i < results.workRecords.length; i++) {
        if (revisionColors.workRecords[i] && results.workRecords[i]) {
          // originalRowIdとorderPositionを保持しながら、style情報をマージ
          const originalRowId = results.workRecords[i].record?.originalRowId || results.workRecords[i].originalRowId;
          const orderPosition = results.workRecords[i].orderPosition;
          results.workRecords[i] = Object.assign({}, revisionColors.workRecords[i]);
          if (originalRowId) {
            results.workRecords[i].originalRowId = originalRowId;
          }
          if (orderPosition !== undefined) {
            results.workRecords[i].orderPosition = orderPosition;
          }
        }
      }
    }
    
    // workRecords以外の属性はそのままマージ
    // eslint-disable-next-line no-unused-vars
    const { workRecords: unusedWorkRecords, ...otherColors } = revisionColors;
    results = Object.assign(results, otherColors);

    //signs
    results["signs"] = [];
    for (const sign of diaryRevisions[0]["signs"]) {
      // presignedUrlとobjectKeyが存在することを確認
      if (sign.sign && !sign.sign.presignedUrl) {
        sign.sign.presignedUrl = sign.sign.objectKey;
      }
      results["signs"].push(sign);
    }
    let sign_length = diaryRevisions[0]["signs"].length;
    if (sign_length < 8) {
      for (let ind = 0; ind < 8 - sign_length; ind++) {
        results["signs"].push({
          sign: {
            jobTitle: "",
            name: "",
            presignedUrl: "",
            objectKey: "",
          },
          order: sign_length + ind + 1,
        });
      }
    }
    //co2InSiteWork
    //co2OutSiteWork
    results["co2InSiteWork"] = [];
    for (const inSiteWOrk of diaryRevisions[0]["co2"]["inSiteWork"]) {
      results["co2InSiteWork"].push(inSiteWOrk.inSiteWork);
    }
    results["co2OutSiteWork"] = [];
    results["co2OutSiteWorkWaste"] = [];
    results["co2OutSiteWorkContructionSoil"] = [];
    for (const outSiteWork of diaryRevisions[0]["co2"]["outSiteWork"]) {
      if (outSiteWork.outSiteWork) {
        results["co2OutSiteWork"].push(outSiteWork.outSiteWork);
        if (outSiteWork.outSiteWork.machineType == "wasteRelated") {
          results["co2OutSiteWorkWaste"].push(outSiteWork.outSiteWork);
        }
        if (outSiteWork.outSiteWork.machineType == "contructionSoil") {
          results["co2OutSiteWorkContructionSoil"].push(
            outSiteWork.outSiteWork
          );
        }
      }
    }
    //sitePatrol
    results["sitePatrolRecords"] = [];
    let countSitePatrol = 0;
    let site = [];
    for (const sitePatrol of diaryRevisions[0].sitePatrolRecords) {
      site.push(sitePatrol);
      countSitePatrol++;
      if (countSitePatrol == 7) {
        results["sitePatrolRecords"].push({ site: site });
        countSitePatrol = 0;
        site = [];
      }
    }
    //meetingDateTime
    results["meetingDateTime"] = moment(diaryRevisions[0].meetingDateTime);
  } catch (errors) {
    console.log("errors", errors);
  }
  return results;
};

export default {
  getAttributeDashboard,
  getSubAttributeDashboard,
  calcStyle,
  createTemplate,
  createTemplatePreviousValue,
  compareRevision,
  getLastestPreviousDiary,
  compareLastestPreviousDiary,
  separateLastestPreviousDiary,
  swapDiarySerializer,
  serializerDiaryRevision,
  findElementRevision,
  resolveActualComparisonTarget,
  syncCarryingIoLength,
};
